import {useSetRecoilState} from 'recoil';
import {Language} from 'webapp-lib/utils';

import handledUserBackend, {
  LoggedInUserInformation,
} from '@lexian/api/user-api';
import {languageState} from '_/state/language';
import {userState} from '_/state/user';

export const useReloadUserInformation = (
  onSuccess: (userInfo: LoggedInUserInformation) => void = () => {}
): (() => void) => {
  const setUser = useSetRecoilState(userState);
  const setLanguage = useSetRecoilState(languageState);

  return () => {
    handledUserBackend.getLoggedInUserInformation({
      parameters: {},
      onSuccess: ({body}) => {
        setLanguage(
          body.locale.startsWith('de') ? Language.German : Language.English
        );
        setUser(body);
        onSuccess(body);
      },
    });
  };
};
